var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","z-index":"10","text-align":"center","background-color":"rgba(255, 255, 255, 0.5)"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"green darken-1","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }